module.exports = __webpack_public_path__ + "img/img_100yuan@2x.bcc4d905.png";